var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tab_panel",staticClass:"tab__panel"},[_c('el-tabs',{key:_vm.updateKey,class:['tabs', 'big', _vm.shadowTabs ? 'tabs--shadow' : ''],attrs:{"addable":_vm.addButton,"before-leave":_vm.beforeLeave},on:{"tab-click":function($event){return _vm.tabClick($event)},"tab-add":function($event){return _vm.$emit('addTab')},"tab-remove":function($event){return _vm.$emit('removeTab', _vm.getActiveTab)}},model:{value:(_vm.activeIdTab),callback:function ($$v) {_vm.activeIdTab=$$v},expression:"activeIdTab"}},_vm._l((_vm.tabs),function(tab,i){return _c('el-tab-pane',{key:`${i}_${tab.id}_${tab.name}`,class:[
        'tab',
        tab.id == 'candidates' ||
        tab.id == 'responds' ||
        tab.id == 'respondsTable'
          ? 'tab-candidate'
          : ''
      ],attrs:{"name":tab.id,"closable":tab.id == _vm.activeIdTab && !!_vm.closable,"disabled":tab.disabled}},[_c('span',{staticClass:"label",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"tab-label"},[(tab.icon)?_c('Picture',{staticClass:"tab-label__img",attrs:{"url":tab.icon,"width":"24","height":"24"}}):_vm._e(),_c('p',{staticClass:"tab-label__text"},[_vm._v(_vm._s(_vm.setTabNameText(tab)))])],1)]),(
          _vm.loading ||
          (_vm.getActiveTab.id === 'communications' &&
            !Object.keys(_vm.communicationParams).length)
        )?_c('div',{staticClass:"tab__loading"},[_c('Loader',{attrs:{"size":"large"}})],1):_vm._e(),(
          _vm.getActiveTab.id === 'checklist' &&
          tab.id === 'checklist' &&
          _vm.getActiveTabData &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].metadata &&
          !_vm.loading
        )?_c('AssessmentTab',{attrs:{"metadata":_vm.getActiveTabData[_vm.getActiveTab.id]},on:{"reloadTab":_vm.reloadTab}}):_vm._e(),(
          _vm.getActiveTab.id === 'responds' &&
          tab.id === 'responds' &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].data &&
          !_vm.loading
        )?_c('RespondsTab'):_vm._e(),(
          _vm.getActiveTab.id === 'respondsTable' &&
          tab.id === 'respondsTable' &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          !_vm.loading
        )?_c('RespondsTableTab',{attrs:{"data":_vm.getActiveTabData[_vm.getActiveTab.id]}}):_vm._e(),(
          _vm.getActiveTab.id === 'events' &&
          tab.id === 'events' &&
          _vm.getActiveTabData &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].data &&
          !_vm.loading
        )?_c('EventTab',{attrs:{"metadata":_vm.getActiveTabData[_vm.getActiveTab.id]},on:{"reloadTab":_vm.reloadTab,"set-loading":val => _vm.tabLoading(val)}}):_vm._e(),(
          _vm.getActiveTab.id === 'vacancy' &&
          tab.id === 'vacancy' &&
          _vm.getActiveTabData &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          !_vm.loading
        )?_c('VacanciesTab',{attrs:{"metadata":_vm.getActiveTabData},on:{"set-loading":val => _vm.tabLoading(val)}}):_vm._e(),(
          _vm.getActiveTab.id === 'candidate_questionnaire' &&
          tab.id === 'candidate_questionnaire' &&
          _vm.getActiveTabData &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].data &&
          !_vm.loading
        )?_c('QuestionnairesTab',{attrs:{"metadata":_vm.getActiveTabData[_vm.getActiveTab.id]},on:{"reloadTab":_vm.reloadTab,"set-loading":val => _vm.tabLoading(val)}}):_vm._e(),(
          _vm.getActiveTab.id === 'documents' &&
          tab.id === 'documents' &&
          !_vm.loading &&
          _vm.getActiveTabData
        )?_c('DocumentTab',{attrs:{"module":_vm.getActiveTab.intents &&
          _vm.getActiveTab.intents.length &&
          _vm.getActiveTab.intents[0].module
            ? _vm.getActiveTab.intents[0].module
            : _vm.module,"metadata":_vm.getActiveTabData[_vm.getActiveTab.id],"id":_vm.getActiveTab.intents &&
          _vm.getActiveTab.intents.length &&
          _vm.getActiveTab.intents[0].request &&
          _vm.getActiveTab.intents[0].request.request_params &&
          _vm.getActiveTab.intents[0].request.request_params.record
            ? _vm.getActiveTab.intents[0].request.request_params.record
            : _vm.$route.params.id,"tabData":tab},on:{"reloadTab":_vm.reloadTab,"set-loading":_vm.tabLoading}}):_vm._e(),(
          _vm.getActiveTab.id === 'audit' &&
          tab.id === 'audit' &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          !_vm.loading
        )?_c('HistoryTab',{attrs:{"module":_vm.module,"tab-id":tab.id}}):_vm._e(),(
          _vm.getActiveTab.id === 'description' &&
          tab.id === 'description' &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          !_vm.loading
        )?_c('description-tab',{attrs:{"fields":tab.fields_arr,"metadata":_vm.getActiveTabData[_vm.getActiveTab.id].metadata},on:{"reloadTab":_vm.reloadTab}}):_vm._e(),(_vm.getActiveTab.id === 'plan' && tab.id === 'plan' && !_vm.loading)?_c('application-stages-tab',{attrs:{"user-id":_vm.$route.params.id,"id":_vm.candidateId,"module":_vm.module},on:{"set-loading":val => _vm.tabLoading(val)}}):_vm._e(),(
          _vm.getActiveTab.id === 'communications' &&
          tab.id === 'communications' &&
          !_vm.loading &&
          Object.keys(_vm.communicationParams).length
        )?_c('communication-tab',{attrs:{"tab":tab,"id":_vm.candidateId,"table-sql":_vm.tabSubpanel(tab),"user-id":_vm.userId,"module":_vm.module,"allowed-scroll":true,"params":_vm.communicationParams},on:{"set-loading":val => _vm.tabLoading(val)}}):_vm._e(),(
          _vm.getActiveTab.id === 'comments' &&
          tab.id === 'comments' &&
          _vm.getActiveTabData[_vm.getActiveTab.id]
        )?_c('comment-tab',{attrs:{"mode":"subpanels","user-id":_vm.userId,"id":_vm.candidateId,"loading":_vm.loading,"module":_vm.module,"table-sql":_vm.tabSubpanel(tab)},on:{"set-loading":val => _vm.tabLoading(val)}}):_vm._e(),(
          _vm.getActiveTab.id === 'selection' &&
          tab.id === 'selection' &&
          !_vm.loading
        )?_c('vacancy-steps',{on:{"set-loading":val => _vm.tabLoading(val)}}):_vm._e(),(
          _vm.getActiveTab.id === 'publicator' &&
          tab.id === 'publicator' &&
          !_vm.loading
        )?_c('publicator-tab',{attrs:{"module":_vm.module,"id":_vm.$route.params.id},on:{"reloadTab":_vm.reloadTab,"set-loading":val => _vm.tabLoading(val)}}):_vm._e(),(
          _vm.getActiveTab.type === 'candidates_resume' &&
          tab.id !== 'resume' &&
          tab.id == _vm.getActiveTab.id &&
          _vm.getActiveTabData &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].metadata &&
          !_vm.loading
        )?_c('ResumeEditTab',{attrs:{"candidateId":_vm.candidateId,"id":tab.id,"fields":_vm.getActiveTabData[_vm.getActiveTab.id].bean,"metaData":_vm.getActiveTabData[_vm.getActiveTab.id].metadata}}):_vm._e(),(
          _vm.getActiveTab.type === 'resumes_list' &&
          tab.id == 'resumes_list' &&
          tab.id == _vm.getActiveTab.id &&
          _vm.getActiveTabData &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].metadata &&
          !_vm.loading
        )?_c('ResumeListTab',{attrs:{"metaData":Array.isArray(_vm.getActiveTabData[_vm.getActiveTab.id].metadata)
            ? {}
            : _vm.getActiveTabData[_vm.getActiveTab.id].metadata}}):_vm._e(),(
          tab.id == _vm.getActiveTab.id &&
          _vm.getActiveTab.type == 'resume' &&
          _vm.getActiveTabData &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].length &&
          !_vm.loading
        )?_c('resume-tab',{attrs:{"id":_vm.getActiveTab.id}}):_vm._e(),(
          _vm.getActiveTab.id === 'candidates' &&
          tab.id === 'candidates' &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].data &&
          !_vm.loading
        )?_c('candidates-tab'):_vm._e(),(
          _vm.getActiveTab.id === 'calls' &&
          tab.id === 'calls' &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          !_vm.loading
        )?_c('calls-tab',{attrs:{"metadata":_vm.getActiveTabData[_vm.getActiveTab.id]}}):_vm._e(),(_vm.getActiveTab.id === 'duplicates' && tab.id === 'duplicates')?_c('doubles-tab',{attrs:{"tabs":_vm.getActiveTab?.subpanel_collection}}):_vm._e(),(
          _vm.getActiveTab.id === 'mark_as_diff_duplicates' &&
          tab.id === 'mark_as_diff_duplicates' &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].data &&
          !_vm.loading
        )?_c('doubles-sub-tab'):_vm._e(),(
          _vm.getActiveTab.id === 'found_duplicates' &&
          tab.id === 'found_duplicates' &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].data &&
          !_vm.loading
        )?_c('doubles-sub-tab'):_vm._e(),(
          _vm.getActiveTab.id === 'user_roles' &&
          tab.id === 'user_roles' &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].data &&
          !_vm.loading
        )?_c('role-tab'):_vm._e(),(
          _vm.getActiveTab.id === 'vacancies' &&
          tab.id === 'vacancies' &&
          _vm.getActiveTabData[_vm.getActiveTab.id] &&
          _vm.getActiveTabData[_vm.getActiveTab.id].data &&
          !_vm.loading
        )?_c('vacancies-list-tab'):_vm._e()],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }